import { FC } from "react";
import styled from "styled-components";

export const CountBadge = styled.span`
  background: #75698d;
  border-radius: 100px;
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 2px 6px;
  gap: 8px;
  font-size: 12px;
`;

interface RecentUnsafeCountProps {
  count: number;
}

const RecentUnsafeCount: FC<RecentUnsafeCountProps> = ({ count }) => (
  <CountBadge>{count}</CountBadge>
);

export default RecentUnsafeCount;
